const dashboardEn = {
  dashboard: {
    filters: {
      professionals: 'Professionals',
      allProfessionals: 'All professionals',
      period: 'Period',
    },
    periods: {
      thisWeek: 'This week',
      lastWeek: 'Last week',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisYear: 'This year',
      lastYear: 'Last year',
    },
    metrics: {
      appointments: 'Appointments',
      appointmentsSubtitle: 'Booked in the selected period',
      revenue: 'Revenue received',
      revenueSubtitle: 'Store total — not affected by the Professionals filter',
      newCustomers: 'New customers',
      newCustomersSubtitle: 'Customers created in the last {{days}} days',
      returnRate: 'Return rate',
      returnRateSubtitle: 'Existing customers who came back',
      newCustomerReturnRate: 'New customers who return',
      newCustomerReturnRateSubtitle: 'New customers who booked a second appointment',
      ofCustomers: '{{returned}} of {{total}} customers',
      ofNewCustomers: '{{repeat}} of {{total}} new customers',
    },
    rates: {
      window: '{{days}} days',
      ignoreInactive: 'Ignore inactive customers',
      ignoreInactiveHelp: 'Leaves out customers without an appointment in the last 6 months',
    },
    peak: {
      title: 'Peak times',
      subtitle: 'Occupancy by weekday and hour, last 30 days',
      closed: 'Closed',
      cellTooltip: '{{weekday}} {{hour}} · {{percent}}',
    },
    cards: {
      topServices: 'Top services',
      topServicesSubtitle: 'Most booked services, compared with the previous period',
      topServicesBookings: '{{count}} bookings',
      topServicesPrevious: 'Previous: {{count}}',
      topTeamMembers: 'Top professionals',
      topTeamMembersSubtitle: 'Revenue received by professional',
      topTeamMembersAppointments: '{{count}} appointments',
      recentActivity: 'Recent activity',
      recentActivitySubtitle: 'Latest events in the store',
      recentSales: 'Recent sales',
      recentSalesSubtitle: 'Latest appointments paid',
      emptyServices: 'No services booked in this period',
      emptyTeamMembers: 'No revenue received in this period',
      emptyActivity: 'No recent activity',
      emptySales: 'No recent sales',
      emptyCustomers: 'No customers yet',
    },
    states: {
      error: 'This card could not be loaded.',
      retry: 'Try again',
    },
  },
};

const dashboardPt = {
  dashboard: {
    filters: {
      professionals: 'Profissionais',
      allProfessionals: 'Todos os profissionais',
      period: 'Período',
    },
    periods: {
      thisWeek: 'Esta semana',
      lastWeek: 'Semana passada',
      thisMonth: 'Este mês',
      lastMonth: 'Mês passado',
      thisYear: 'Este ano',
      lastYear: 'Ano passado',
    },
    metrics: {
      appointments: 'Agendamentos',
      appointmentsSubtitle: 'Marcados no período selecionado',
      revenue: 'Receita recebida',
      revenueSubtitle: 'Total da loja — não é afetado pelo filtro de Profissionais',
      newCustomers: 'Novos clientes',
      newCustomersSubtitle: 'Clientes criados nos últimos {{days}} dias',
      returnRate: 'Taxa de retorno',
      returnRateSubtitle: 'Clientes existentes que voltaram',
      newCustomerReturnRate: 'Novos clientes que retornam',
      newCustomerReturnRateSubtitle: 'Novos clientes que marcaram um segundo agendamento',
      ofCustomers: '{{returned}} de {{total}} clientes',
      ofNewCustomers: '{{repeat}} de {{total}} novos clientes',
    },
    rates: {
      window: '{{days}} dias',
      ignoreInactive: 'Ignorar clientes inativos',
      ignoreInactiveHelp: 'Desconsidera clientes sem agendamento nos últimos 6 meses',
    },
    peak: {
      title: 'Horários de pico',
      subtitle: 'Ocupação por dia da semana e hora, últimos 30 dias',
      closed: 'Fechado',
      cellTooltip: '{{weekday}} {{hour}} · {{percent}}',
    },
    cards: {
      topServices: 'Serviços mais procurados',
      topServicesSubtitle: 'Serviços mais agendados, comparados com o período anterior',
      topServicesBookings: '{{count}} agendamentos',
      topServicesPrevious: 'Anterior: {{count}}',
      topTeamMembers: 'Profissionais em destaque',
      topTeamMembersSubtitle: 'Receita recebida por profissional',
      topTeamMembersAppointments: '{{count}} agendamentos',
      recentActivity: 'Atividade recente',
      recentActivitySubtitle: 'Últimos eventos da loja',
      recentSales: 'Vendas recentes',
      recentSalesSubtitle: 'Últimos agendamentos pagos',
      emptyServices: 'Nenhum serviço agendado neste período',
      emptyTeamMembers: 'Nenhuma receita recebida neste período',
      emptyActivity: 'Sem atividade recente',
      emptySales: 'Sem vendas recentes',
      emptyCustomers: 'Ainda não há clientes',
    },
    states: {
      error: 'Não foi possível carregar este cartão.',
      retry: 'Tentar novamente',
    },
  },
};

const dashboardEs = {
  dashboard: {
    filters: {
      professionals: 'Profesionales',
      allProfessionals: 'Todos los profesionales',
      period: 'Periodo',
    },
    periods: {
      thisWeek: 'Esta semana',
      lastWeek: 'Semana pasada',
      thisMonth: 'Este mes',
      lastMonth: 'Mes pasado',
      thisYear: 'Este año',
      lastYear: 'Año pasado',
    },
    metrics: {
      appointments: 'Citas',
      appointmentsSubtitle: 'Reservadas en el periodo seleccionado',
      revenue: 'Ingresos cobrados',
      revenueSubtitle: 'Total del local — no le afecta el filtro de Profesionales',
      newCustomers: 'Clientes nuevos',
      newCustomersSubtitle: 'Clientes creados en los últimos {{days}} días',
      returnRate: 'Tasa de retorno',
      returnRateSubtitle: 'Clientes existentes que volvieron',
      newCustomerReturnRate: 'Clientes nuevos que regresan',
      newCustomerReturnRateSubtitle: 'Clientes nuevos que reservaron una segunda cita',
      ofCustomers: '{{returned}} de {{total}} clientes',
      ofNewCustomers: '{{repeat}} de {{total}} clientes nuevos',
    },
    rates: {
      window: '{{days}} días',
      ignoreInactive: 'Ignorar clientes inactivos',
      ignoreInactiveHelp: 'Excluye clientes sin cita en los últimos 6 meses',
    },
    peak: {
      title: 'Horas punta',
      subtitle: 'Ocupación por día de la semana y hora, últimos 30 días',
      closed: 'Cerrado',
      cellTooltip: '{{weekday}} {{hour}} · {{percent}}',
    },
    cards: {
      topServices: 'Servicios más solicitados',
      topServicesSubtitle: 'Servicios más reservados, comparados con el periodo anterior',
      topServicesBookings: '{{count}} reservas',
      topServicesPrevious: 'Anterior: {{count}}',
      topTeamMembers: 'Profesionales destacados',
      topTeamMembersSubtitle: 'Ingresos cobrados por profesional',
      topTeamMembersAppointments: '{{count}} citas',
      recentActivity: 'Actividad reciente',
      recentActivitySubtitle: 'Últimos eventos del local',
      recentSales: 'Ventas recientes',
      recentSalesSubtitle: 'Últimas citas pagadas',
      emptyServices: 'Ningún servicio reservado en este periodo',
      emptyTeamMembers: 'Sin ingresos cobrados en este periodo',
      emptyActivity: 'Sin actividad reciente',
      emptySales: 'Sin ventas recientes',
      emptyCustomers: 'Aún no hay clientes',
    },
    states: {
      error: 'No se pudo cargar esta tarjeta.',
      retry: 'Intentar de nuevo',
    },
  },
};

export const dashboardTranslationsEn = dashboardEn;
export const dashboardTranslationsPt = dashboardPt;
export const dashboardTranslationsEs = dashboardEs;
